import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";

import { BoxSpg, DividerSpg, ApplicationSubtype, RecognitionKind } from "@duosoftbg/nacid-components";
import { Button, Typography } from "@mui/material";
import { FormProvider } from "react-hook-form";
import { toast } from "react-toastify";
import { baseEndpointPaths } from "../../../../../../services/serviceCalls";
import useFormReset from "../../../../../../hooks/useFormReset";
import useStepSpecific from "../../../../../../hooks/useStepSpecific";
import { useTranslation } from "react-i18next";
import React from "react";
import { createSEEducationValidationSchema } from "../../../../../../yup/secondaryEducation/seEducationValidationSchemas";
import {
  completeEducationStep,
  setStepEducationEdited,
} from "../../../../../../store/redux/slice/Forms/seRecognitionForm";
import { initialSeRecognitionEducation } from "../../../../../../init/seRecognitionInitialValues";
import SecondarySchoolFormSection from "./SecondarySchoolFormSection";
import DiplomaDataFormSection from "./DiplomaDataFormSection";
import StudiedSubjectFormSection from "./StudiedSubjectFormSection";
import RecognitionPurposeFormSection from "./RecognitionPurposeFormSection";
import useStepSpecificValidation from "../../../../../../hooks/useStepSpecificValidation";
import PartialFormDataDialog from "../../../common/form/validation/PartialFormDataDialog";
import { createFormalValidationFromSchema } from "../../../../../../yup/utils/yupUtils";
import ServiceSelectionSection from "./ServiceSelectionSection";
import AdditionalStudiedSubjectFormSection from "./AdditionalStudiedSubjectFormSection";
import AdditionalInfoFormSection from "./AdditionalInfoFormSection";

const SeRecognitionStepEducation = () => {
  const { t } = useTranslation();

  const seRecognitionForm = useAppSelector((state) => {
    return state.Forms.SERecognitionForm;
  });

  const fullSchema = createSEEducationValidationSchema;
  const formalSchema = createFormalValidationFromSchema(fullSchema);

  const { onSubmit, methods } = useStepSpecific(
    seRecognitionForm.educationDetails,
    seRecognitionForm.id,
    baseEndpointPaths.seRecognition,
    formalSchema,
    setStepEducationEdited,
    completeEducationStep,
    initialSeRecognitionEducation,
  );

  const { onSubmitWithValidations, handleCancel, handleAccept, showModal } = useStepSpecificValidation(
    fullSchema,
    formalSchema,
    methods,
    onSubmit,
  );

  useFormReset(ApplicationSubtype.SE_RECOGNITION, seRecognitionForm.educationDetails, methods.reset);

  return (
    <BoxSpg>
      <FormProvider {...methods}>
        <form
          onSubmit={methods.handleSubmit(onSubmitWithValidations, (errors) => {
            toast.error(t("m.validation.errors.present"));
          })}
        >
          <ServiceSelectionSection isSubmittedOrFinalized={seRecognitionForm.submittedOrFinalized} />
          <RecognitionPurposeFormSection recognitionKind={RecognitionKind.CERTIFICATE} />
          <SecondarySchoolFormSection />
          <DiplomaDataFormSection
            infoMessage={"m.grading.scale.data.info"}
            profQualifSection={true}
            gradingScaleSection={true}
            label={"t.school.diploma.se"}
          />
          <StudiedSubjectFormSection label={"t.studied.subjects.se"} />
          <AdditionalStudiedSubjectFormSection />
          <AdditionalInfoFormSection />
          <DividerSpg my={4} />
          <BoxSpg>
            <Typography align={"left"}>
              <Button type={"submit"} variant={"contained"}>
                {t("l.btn.saveData")}
              </Button>
            </Typography>
          </BoxSpg>
        </form>
      </FormProvider>
      <PartialFormDataDialog open={showModal} handleCancel={handleCancel} handleAccept={handleAccept} />
    </BoxSpg>
  );
};
export default SeRecognitionStepEducation;
